import { map } from './map';
import { seq } from './seq';
import { string } from './string';
export var failsafe = [map, seq, string];